import { createContext, useContext, useState } from 'react';

interface ScorecardsFilterContextType {
  activeSeverities: Set<string>;
  activeCategories: Set<string>;
  setActiveSeverities: (v: Set<string>) => void;
  setActiveCategories: (v: Set<string>) => void;
}

const ScorecardsFilterContext = createContext<
  ScorecardsFilterContextType | undefined
>(undefined);

export const ScorecardsFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [activeSeverities, setActiveSeverities] = useState<Set<string>>(
    new Set(),
  );
  const [activeCategories, setActiveCategories] = useState<Set<string>>(
    new Set(),
  );

  return (
    <ScorecardsFilterContext.Provider
      value={{
        activeSeverities,
        activeCategories,
        setActiveSeverities,
        setActiveCategories,
      }}
    >
      {children}
    </ScorecardsFilterContext.Provider>
  );
};

export const useScorecardsFilter = () => {
  const context = useContext(ScorecardsFilterContext);
  if (!context)
    throw new Error(
      'useScorecardsFilter must be used within ScorecardsFilterProvider',
    );
  return context;
};
